import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        timeSeconds: '获取验证码'
    },
    mutations: {
        timeChange (state, data) {
            state.timeSeconds = data
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js